import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiError } from '../schemas/common.schema';

const c = initContract();

export const geminiContract = c.router({
  testGenerate: {
    method: 'POST',
    path: '/gemini/test/generate',
    body: z.object({ prompt: z.string(), model: z.string().optional() }),
    responses: {
      200: z.object({ success: z.boolean(), data: z.object({ text: z.string() }) }),
      400: apiError,
      502: apiError,
    },
  },
});
